import React, { useState, useEffect } from "react";
import login from "../../../assets/images/png/login.png";
import logo from "../../../assets/images/logo/logocopy.svg";
import { useNavigate } from 'react-router-dom';
import { baseurl } from '../../../helper/Baseurl';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { FaSpinner } from 'react-icons/fa';
import { useTranslation } from "../../../context/TranslationContext";
import { Paper } from '@mui/material';


const InputField = ({ id, label, type, value, onChange, error, isRtl, placeholder }) => (
  <div className={`flex flex-col pt-4 ${isRtl ? 'text-right' : 'text-left'}`}>
    <label className="text-lg font-tajwal">{label}</label>
    <input
      id={id}
      name={id}
      type={type}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      className={`shadow-md border rounded-lg w-full py-2 px-3 text-gray-700 mt-1 leading-tight focus:outline-none focus:ring-2 focus:ring-primary-blue ${isRtl ? 'text-right' : 'text-left'}`}
    />
    {error && <p className="text-red-500 text-xs mx-1 mt-1">{error}</p>}
  </div>
);

const Login = () => {
  const { translations, language } = useTranslation();
  const isRtl = language === "ar";
  const navigate = useNavigate();

  const [values, setValues] = useState({ username: '', password: '' });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const handleChange = ({ target: { name, value } }) => {
    setValues(prev => ({ ...prev, [name]: value }));
    setErrors(prev => ({ ...prev, [name]: '' }));
  };

  const validate = () => {
    let valid = true;
    const newErrors = {};

    if (!values.username) {
      newErrors.username = translations.emailError1;
      valid = false;
    } else if (!/\S+@\S+\.\S+/.test(values.username)) {
      newErrors.username = translations.emailError;
      valid = false;
    }

    if (!values.password) {
      newErrors.password = translations.passwordError;
      valid = false;
    } else if (values.password.length < 4) {
      newErrors.password = translations.passwordLengthError;
      valid = false;
    }

    setErrors(newErrors);
    return valid;
  };

  const handleClick = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    setLoading(true);
    try {
      const res = await axios.post(`${baseurl}authenticate`, values);
      if (res.status === 200 && res.data.id_token) {
        localStorage.setItem('token', res.data.id_token);
        toast.success(translations.welcome);
        navigate('/HomeAfterLogin');
      }
    } catch (err) {
      err.response?.status === 401
        ? toast.warning(translations.passwordErrortoast)
        : toast.error(translations.inputError);
    } finally {
      setLoading(false);
    }
  };

  const handleKeyDown = (e) => e.key === 'Enter' && handleClick(e);

  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [values]);

  return (
    <div className="w-full h-screen flex items-center justify-center bg-white font-tajwal">
      <div className="w-full md:w-2/3 p-6">
        <Paper elevation={5} sx={{ borderRadius: '8px', backgroundColor: '#d0dee430', padding: 4 }}>
          <div className={`grid grid-cols-1 md:flex ${isRtl ? 'md:flex-row' : 'md:flex-row-reverse'} gap-4 mt-10`}>
            
            {/* Image Section */}
            <div className="flex-col justify-center items-center w-full md:w-1/2">
              <div className="w-full flex justify-center items-center">
                <img src={logo} alt="Logo" className="mb-2 w-[20%]" />
              </div>
              <div className="w-full text-center mb-5">
                <h2 className="text-2xl font-bold mb-2">{translations.platformWelcome}</h2>
                <p className="text-gray-500">{translations.continueWatching1}</p>
              </div>
              <div className="w-full flex justify-center items-center">
                <img src={login} alt="Login Illustration" className="w-[50%]" />
              </div>
            </div>

            {/* Form Section */}
            <form className="w-full md:w-1/2" onSubmit={handleClick}>
              <div className={`md:mt-20`}>
                <InputField
                  id="username"
                  label={translations.email}
                  type="email"
                  value={values.username}
                  onChange={handleChange}
                  error={errors.username}
                  isRtl={isRtl}
                  placeholder="your@email.com"
                />

                <InputField
                  id="password"
                  label={translations.password}
                  type="password"
                  value={values.password}
                  onChange={handleChange}
                  error={errors.password}
                  isRtl={isRtl}
                  placeholder="********"
                />
              </div>

              <button
                type="submit"
                disabled={loading}
                className={`bg-primary-blue mt-10 w-full text-lg text-white font-bold py-2 px-4 rounded-xl focus:outline-none focus:ring-2 focus:ring-primary-blue ${loading ? "opacity-50 cursor-not-allowed" : ""}`}
              >
                {loading ? <FaSpinner className="animate-spin w-5 h-5 mx-auto" /> : translations.register}
              </button>

              <p className="text-primary-blue text-center mt-8">
                <a href="#">{translations.Forgotpass}</a>
              </p>
              <p className="mt-2 text-center">
                {translations.loginPrompt1}{" "}
                <span className="text-primary-blue cursor-pointer" onClick={() => navigate('/LoginRegister')}>
                  {translations.loginnow}
                </span>
              </p>
            </form>
          </div>
        </Paper>
      </div>
      <ToastContainer />
    </div>
  );
};

export default Login;
